<!--
 * @Description  : 购票须知中的改签提示页
-->
<template minapp="mpx" xlang="wxml">
  <view>
    <explain class="explain1" explainValue="{{explainValue4}}"></explain>
    <explain class="explain1" explainValue="{{explainValue1}}"></explain>
    <explain class="explain2" explainValue="{{explainValue5}}">
      <change-table
        slot="tabrefund" 
        class="refund1" 
      ></change-table>
    </explain>
    <explain class="explain2" explainValue="{{explainValue2}}">
      <refund-table
        slot="tabrefund"
        tableValue="{{tableValue2}}"
        wx:style="{{ {margin: '-12px 0 0 22px'}}}"
      />
      <notes
        slot="other"
        notesList="{{notesList1}}"
        wx:style="{{ {margin: '-24px 0 0 22px'}}}" 
      />
    </explain>
    <explain class="explain3" explainValue="{{explainValue3}}"></explain>
  </view>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'

  createComponent({
    data: {
      isShowTabIcon:true,
      explainValue5: {
        title: '可改签什么时候的票？',
        listText: [
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '开车前和开车后改签规则见下方表格：'
                }
              ]
            }
          ],
        ]
      },
      explainValue1: {
        title: '改签的规则是什么？',
        listText: [
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '1. 可以改动出发日期，车次，席别，'
                }
              ]
            },
            {
              name: 'span',
              attrs: {
                style: 'color: #FF6221;'
              },
              children: [
                {
                  type: 'text',
                  text: '到达站'
                }
              ]
            },
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '。其他不可改动，如出发站（同城车站除外）姓名、证件、票类型等，假如您票面上有姓名错误，是不能通过改签修改的。'
                }
              ]
            }
          ],
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '2. 每张车票只能改签一次，已改签的车票不能再改签。'
                }
              ]
            }
          ],
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '3. 便捷购票如需改签需至车站窗口办理，不支持网上在线改签。'
                }
              ]
            }
          ],
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '4. 已办理开车后改签业务的车票，不能退票。'
                }
              ]
            }
          ]
        ],
        // prompt: '铁路局规定，仅开车前48小时以上，可以改动到达站，48小时内无法办理；取票后只能在车站窗口改签'
      },
      explainValue2: {
        title: '改签产生的费用怎么算?',
        listText: [
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '1. 改签票价格=原票价格，需重新支付改签票价格，原票全额退回原支付账户'
                }
              ]
            }
          ],
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '2. 改签票价格＜原票价格，需重新支付改签票价格，原票费用扣除手续费后退回原支付账户'
                }
              ]
            }
          ],
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '3. 改签票价格＞原票价格，需重新支付改签票价格，原票全额退回原支付账户'
                }
              ]
            }
          ],
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '4. 开车前不足48小时至发车后当日24时前改签发车当日后车次，铁路局会收取一定比例的改签费。'
                }
              ]
            }
          ],
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '5. 改签退差时，票价差额退票费核收标准：'
                }
              ]
            }
          ],
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '&emsp;(1) 旅客变更乘车日期、车次、席位、到站等产生票价差额需退还或补收时，票价差额按“应收一已收“原则计算，其中：“应收”指旅客变更后新车票的票面价格，“已收”指变更前原车票的票面价格。当变更后的票价高于原票价时，应补收票价差额；低于原票价时，应退还票价差额，并按梯次标准核收退票费。'
                }
              ]
            }
          ],
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '&emsp;(2) 退票费按如下梯次标准核收：距票面乘车站开车前8天以上的不收退票费；开车前48小时以上、不足8天的，按票面价格5%计；开车前24小时以上、不足48小时的，按票面价格10%计；开车前不足24小时的，按票面价格20%计。“以上”含本数，下同。'
                }
              ]
            }
          ]
        ]
      },
      explainValue3: {
        title: '改签退款何时到账？',
        listText: [
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '1-15 个工作日，原路退回'
                }
              ]
            }
          ]
        ]
      },
      tableValue2: {
        tabWidth: '151px',
        tableth: ['申请改签距发车时间', '票价差额退票费'],
        tablelist: [
          {
            title: '改签时间≥8天',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '无'
                  }
                ]
              }
            ]
          },
          {
            title: '48小时≤改签时间＜8天',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #ff7d41;'
                },
                children: [
                  {
                    type: 'text',
                    text: '5% '
                  }
                ]
              }
            ]
          },
          {
            title: '24小时≤改签时间＜48小时',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #ff7d41;'
                },
                children: [
                  {
                    type: 'text',
                    text: '10%'
                  }
                ]
              }
            ]
          },
          {
            title: '改签时间＜24小时',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #ff7d41;'
                },
                children: [
                  {
                    type: 'text',
                    text: '20%'
                  }
                ]
              }
            ]
          }
        ],
      },
      notesList1: [
        {
          list: [
            '距票面乘车站开车前48小时以上、不足8天的车票，改签或变更到站至开车前8天以上的列车，又在距开车前8天以上退票的，核收5%的退票费。',
            '退票费以5角为单位，尾数小于2.5角的舍去、2.5角以上且小于7.5角的计为5角、7.5角以上的进为1元。',
            '退票费最低按2元计收，当车票票面价格不足2元时按票面价格计收。',
          ]
        }
      ],
      explainValue4: {
        title: '春运改签有什么特殊规则？',
        listText: [
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '根据铁路局规定：'
                }
              ]
            }
          ],
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '1. 改签或变更到站后的车票乘车日期在春运期间（1月26日至3月5日）的，退票按开车前不足24小时标准（按票面价格20%）核收退票费。'
                }
              ]
            }
          ],
        ],
        // prompt: '铁路局规定，仅开车前48小时以上，可以改动到达站，48小时内无法办理；取票后只能在车站窗口改签'
      },
    },
    mounted() {},
    computed: {},

    methods: {}
  })
</script>

<style scoped lang="stylus">
  .explain1
    margin-bottom 12px
    margin-top 12px
  .explain2
    margin 12px 0
  .refund1
    border-radius 8px
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      explain: '@/components/ticket-guide/explain',
      notes: '@/components/ticket-guide/notes',
      'refund-table': '@/components/ticket-guide/refund-table',
      'change-table': '@/components/ticket-guide/change-table'
    }
  }
</script>